// Fonte: UManutContas.pas ~linha 8984 — tabelas Tarifas + Tarifa_Conta
// Disponível para: Tipo 4 (Fornecedor)
// Validação: Só pode vincular tarifa para fornecedores
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Modal, Spinner, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  listarTarifasConta,
  listarTarifasDisponiveis,
  vincularTarifaConta,
  desvincularTarifaConta,
} from '~/Services/Service';

var TabTarifas = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [vinculadas, setVinculadas] = useState([]);
  var [disponiveis, setDisponiveis] = useState([]);
  var [loading, setLoading] = useState(false);
  var [showModal, setShowModal] = useState(false);
  var [tarifaSelecionada, setTarifaSelecionada] = useState(null);
  var [salvando, setSalvando] = useState(false);
  var [showExcluir, setShowExcluir] = useState(null);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarTarifasConta(ge, codigo)
      .then(function(resp) {
        setVinculadas(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar tarifas'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() {
    carregar();
    listarTarifasDisponiveis()
      .then(function(resp) {
        var data = Array.isArray(resp) ? resp : [];
        setDisponiveis(data.map(function(t) {
          return { value: t.codigo_tarifa, label: t.codigo_tarifa + ' - ' + (t.descricao !== null && t.descricao !== undefined ? t.descricao : '') };
        }));
      })
      .catch(function() {});
  }, [carregar]);

  var handleVincular = function() {
    if (!tarifaSelecionada) { toast.warning('Selecione a tarifa'); return; }
    setSalvando(true);
    vincularTarifaConta(ge, codigo, { codigo_tarifa: tarifaSelecionada.value })
      .then(function() {
        toast.success('Tarifa vinculada!');
        setShowModal(false);
        setTarifaSelecionada(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao vincular tarifa'); })
      .finally(function() { setSalvando(false); });
  };

  var handleDesvincular = function() {
    desvincularTarifaConta(ge, codigo, { codigo_tarifa: showExcluir.codigo_tarifa })
      .then(function() {
        toast.success('Tarifa desvinculada!');
        setShowExcluir(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao desvincular tarifa'); });
  };

  return (
    <div className="contas-tab-content">
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="primary" onClick={function() { setShowModal(true); }}>+ Vincular</Button>
      </div>

      <p className="small font-weight-bold">Tarifas Vinculadas</p>
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Código</th>
              <th>Tarifa</th>
              <th>Tipo</th>
              <th>Incidência</th>
              <th>Preço</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {vinculadas.length === 0 ? (
              <tr><td colSpan={6} className="text-center text-muted">Nenhuma tarifa vinculada</td></tr>
            ) : (
              vinculadas.map(function(item) {
                return (
                  <tr key={item.codigo_tarifa}>
                    <td>{item.codigo_tarifa}</td>
                    <td>{item.descricao !== null && item.descricao !== undefined ? item.descricao : '-'}</td>
                    <td>{item.tipo_tarifa !== null && item.tipo_tarifa !== undefined ? item.tipo_tarifa : '-'}</td>
                    <td>{item.incidencia !== null && item.incidencia !== undefined ? item.incidencia : '-'}</td>
                    <td>{item.preco_tarifa !== null && item.preco_tarifa !== undefined ? item.preco_tarifa : '-'}</td>
                    <td>
                      <Button size="sm" variant="outline-danger" onClick={function() { setShowExcluir(item); }}>Desvincular</Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={function() { setShowModal(false); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Vincular Tarifa</Modal.Title></Modal.Header>
        <Modal.Body>
          <Select
            placeholder="Selecione a tarifa..."
            options={disponiveis}
            value={tarifaSelecionada}
            onChange={setTarifaSelecionada}
            noOptionsMessage={function() { return 'Nenhuma tarifa disponível'; }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowModal(false); }}>Cancelar</Button>
          <Button variant="success" onClick={handleVincular} disabled={salvando}>
            {salvando ? <Spinner animation="border" size="sm" /> : 'Vincular'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!!showExcluir} onHide={function() { setShowExcluir(null); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Confirmar Desvinculação</Modal.Title></Modal.Header>
        <Modal.Body>Deseja desvincular a tarifa <strong>{showExcluir && showExcluir.descricao}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowExcluir(null); }}>Não</Button>
          <Button variant="danger" onClick={handleDesvincular}>Desvincular</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabTarifas;
